import root from 'window-or-global';

export interface LoggerParams {
    [paramName: string]: any;
}

type LoggerMethod = (
    methodName: string,
    msgOrParams?: string | LoggerParams,
    params?: LoggerParams
) => void;

export interface Logger {
    log: LoggerMethod;
    warn: LoggerMethod;
    info: LoggerMethod;
    debug: LoggerMethod;
    off(): Logger;
}

export const writeLog = (outputMethod: any, logMessage: string) => {
    // log if __debugModeEnabled is true
    if (root.__debugModeEnabled) {
        outputMethod(logMessage);
    }
};

// NOTE: this prevents cyclic object value errors
const parseParams = (params: LoggerParams): string => {
    try {
        return JSON.stringify(params);
    } catch (e) {
        return `{loggerError: '${e.message}'}`;
    }
};

export const createLogMessage = (
    className: string,
    methodName: string,
    msgOrParams?: string | LoggerParams,
    params?: LoggerParams
): string => {
    let result: string = `[${className}] ${methodName}`;
    if (msgOrParams) {
        result =
            typeof msgOrParams === 'object'
                ? `${result} ${parseParams(msgOrParams)}`
                : `${result} ${msgOrParams}`;
    }
    if (params) {
        result =
            typeof params === 'object' ? `${result} ${parseParams(params)}` : `${result} ${params}`;
    }
    return result;
};

export const createClassLogger = (className): Logger => {
    const stub: Logger = {
        log: () => {},
        warn: () => {},
        info: () => {},
        debug: () => {},
        off: () => stub
    };

    return {
        log: (methodName, msg, data) =>
            writeLog(console.log, createLogMessage(className, methodName, msg, data)),
        warn: (methodName, msg, data) =>
            writeLog(console.warn, createLogMessage(className, methodName, msg, data)),
        info: (methodName, msg, data) =>
            writeLog(console.info, createLogMessage(className, methodName, msg, data)),
        debug: (methodName, msg, data) =>
            writeLog(console.debug, createLogMessage(className, methodName, msg, data)),
        off: () => stub
    };
};
